import { render, staticRenderFns } from "./index-verify.vue?vue&type=template&id=26ed8824&scoped=true"
import script from "./index-verify.vue?vue&type=script&lang=js"
export * from "./index-verify.vue?vue&type=script&lang=js"
import style0 from "./index-verify.vue?vue&type=style&index=0&id=26ed8824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed8824",
  null
  
)

export default component.exports